import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const OverviewDashboardV2 = lazy(
  () => import("../components/OverviewDashboardV2")
);

const overviewDashboardV2Route: RouteObject = {
  index: true,
  element: <OverviewDashboardV2 />,
};

export default overviewDashboardV2Route;
